<template>
  <div>
    <HomePageTemplate/>
  </div>
</template>

<script>
import HomePageTemplate from '@/components/HomePageTemplate.vue';
export default {
  name: "HomeView",
  components: {
    HomePageTemplate
  }
};
</script>
